import React from "react";

const FieldList = ({ item }) => {
  return (
    <>
      <div className="p-6 border border-gray-200 rounded-lg shadow-md hover:shadow-xl transition duration-300">
        {item.icon ? (
          item.icon()
        ) : (
          <svg
            className="w-10 h-10 text-crimson mb-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"
            ></path>
          </svg>
        )}
        <h3 className="text-xl font-semibold text-gray-900 mb-2">
          {item.title}
        </h3>
        <p className="text-gray-600">{item.description}</p>
      </div>
    </>
  );
};

export default FieldList;
